import React, { useMemo } from 'react';

export default function SkillsSection({ skills, categories }) {
  const groupedSkills = useMemo(() => {
    return skills.reduce((acc, skill) => {
      const list = acc[skill.category] || [];
      acc[skill.category] = [...list, skill];
      return acc;
    }, {});
  }, [skills]);

  return (
    <section className="py-20">
      <h2 className="text-4xl md:text-5xl font-black mb-16 text-center">
        <span className="bg-gradient-to-r from-purple-400 to-cyan-400 text-transparent bg-clip-text">Навыки & Технологии</span>
      </h2>

      <div className="relative max-w-6xl mx-auto mb-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {Object.entries(categories).map(([categoryKey, categoryData]) => {
            const categorySkills = groupedSkills[categoryKey] || [];

            return (
              <div key={categoryKey} className="flex flex-col gap-4">
                <div className="text-center mb-2">
                  <span className={`inline-block px-4 py-2 bg-gradient-to-r ${categoryData.color} rounded-full text-white font-bold text-sm shadow-lg`}>
                    {categoryData.label}
                  </span>
                </div>

                {categorySkills.map((skill) => (
                  <div key={skill.id} className="group relative">
                    <div className={`absolute inset-0 bg-gradient-to-r ${categoryData.color} rounded-2xl blur-lg opacity-0 group-hover:opacity-40 transition-opacity duration-300`} />
                    <div className="relative px-5 py-4 bg-white/5 backdrop-blur-md rounded-2xl border-2 border-white/10 hover:border-white/30 transition-all duration-300 hover:scale-105 text-center cursor-pointer">
                      <div className={`text-base font-bold bg-gradient-to-r ${categoryData.color} text-transparent bg-clip-text`}>{skill.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
